module.exports = __webpack_public_path__ + "img/cp-2.aefb522d.jpg";